import React from 'react';

interface SnoozeIconProps extends React.SVGProps<SVGSVGElement> { }

const SnoozeIcon: React.FC<SnoozeIconProps> = ({ ...props }) => {
    return (
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.3314 10.7459C17.515 11.491 17.8138 12.2028 18.2168 12.8558L18.8952 13.9552C19.5768 15.0588 19.2051 16.1993 17.9194 16.3704C16.4487 16.5659 13.9934 16.7412 9.91569 16.7412C5.83798 16.7412 3.38223 16.5659 1.91201 16.3704C0.626257 16.1993 0.254551 15.0588 0.935705 13.9552L1.61455 12.8558C2.22119 11.8729 2.58861 10.7613 2.68724 9.61052L2.90861 7.03255C3.21944 3.39481 6.26319 0.600098 9.91569 0.600098C10.8076 0.600098 11.6635 0.767043 12.4521 1.07188" stroke="#7F7182" stroke-width="1.2" stroke-linecap="round" />
            <path d="M14.0662 2.90576H19.1391L14.5274 8.43985H19.6003M9.45447 6.59515H12.8363L9.76207 10.2845H13.1439" stroke="#7F7182" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M6.24792 16.6848C6.34779 17.5877 6.77719 18.422 7.45389 19.028C8.13059 19.6339 9.00704 19.969 9.91541 19.969C10.8238 19.969 11.7002 19.6339 12.3769 19.028C13.0536 18.422 13.483 17.5877 13.5829 16.6848" stroke="#7F7182" stroke-width="1.2" />
        </svg>

    );
};

export default SnoozeIcon;